<template>
  <div class="mitarbeiter-data">
    <v-row no-gutters align="baseline">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Vollzeitmitarbeiter
        </span>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="anzahlVollzeit"
                      v-validate="'required|numeric|min_value:0|mitarbeiteranzahl'"
                      :error-messages="errors.collect('anzahlVollzeit', scope)"
                      data-vv-as="Anzahl Vollzeitmitarbeiter"
                      :data-vv-scope="scope"
                      data-vv-name="anzahlVollzeit"
                      placeholder="Anzahl Vollzeitmitarbeiter *"
                      :hint="hintSchubladentarif"
                      persistent-hint
                      @input="$emit('pricechanged')" />
      </v-col>
    </v-row>

    <v-row no-gutters align="baseline">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Teilzeit-/Leiharbeiter (entspricht 0,5 Mitarbeiter)
        </span>
        <site-tooltip>Als Teilzeitbeschäftigte gelten Beschäftigte, deren durchschnittliche wöchentliche Arbeitszeit 30 Stunden nicht überschreitet.</site-tooltip>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="anzahlTeilzeit"
                      v-validate="'required|numeric|min_value:0|mitarbeiteranzahl'"
                      :error-messages="errors.collect('anzahlTeilzeit', scope)"
                      data-vv-as="Anzahl Teilzeit-/Leiharbeiter"
                      :data-vv-scope="scope"
                      data-vv-name="anzahlTeilzeit"
                      placeholder="Anzahl Teilzeit-/Leiharbeiter *"
                      :hint="hintSchubladentarif"
                      persistent-hint
                      @input="$emit('pricechanged')" />
      </v-col>
    </v-row>

    <v-row no-gutters align="baseline">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Sonstige Mitarbeiter (entspricht 0,25 Mitarbeiter)<br>(Azubi, ABM, Aushilfen, geringfügig Beschäftigte)
        </span>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="anzahlSonstige"
                      v-validate="'required|numeric|min_value:0|mitarbeiteranzahl'"
                      :error-messages="errors.collect('anzahlSonstige', scope)"
                      data-vv-as="Anzahl sonstige Mitarbeiter"
                      :data-vv-scope="scope"
                      data-vv-name="anzahlSonstige"
                      placeholder="Anzahl sonstige Mitarbeiter *"
                      :hint="hintSchubladentarif"
                      persistent-hint
                      @input="$emit('pricechanged')" />
      </v-col>
    </v-row>

    <v-row no-gutters align="baseline">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Mitarbeitende Familienangehörige ersten Grades (beitragsfrei)
        </span>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="anzahlFamilie"
                      v-validate="'required|numeric|min_value:0|max_value:999'"
                      :error-messages="errors.collect('anzahlFamilie', scope)"
                      data-vv-as="Anzahl mitarbeitende Familienangehörige"
                      :data-vv-scope="scope"
                      data-vv-name="anzahlFamilie"
                      placeholder="Anzahl mitarbeitende Familienangehörige *" />
      </v-col>
    </v-row>

    <v-row no-gutters align="baseline">
      <v-col cols="12"
             sm="6">
        <span class="dmb-form-text">Inhaber/Geschäftsführer </span>
        <site-tooltip titel="Inhaber/Geschäftsführer">
            Im KOMPEX ist der erste Inhaber/Geschäftsführer im privaten Bereich <strong>beitragsfrei</strong> mitversichert.
        </site-tooltip>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-model="anzahlInhaber"
                      v-validate="'required|numeric|min_value:0|max_value:99'"
                      :error-messages="errors.collect('anzahlInhaber', scope)"
                      data-vv-as="Anzahl Inhaber/Geschäftsführer"
                      :data-vv-scope="scope"
                      data-vv-name="anzahlInhaber"
                      placeholder="Anzahl Inhaber/Geschäftsführer *" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import twowayBindingMixin, { mapTwoWay } from '../../store/twowayBindingMixin';
import ValidationMixin from '../helper/ValidationMixin';
import {mapGetters} from "vuex";

export default {
  name: "MitarbeiterData",
  mixins: [ twowayBindingMixin, ValidationMixin ],
  props: {
    scope: {
      type: String,
      required: false,
      default: undefined
    },
    kompex: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    limitMitarbeiter() {
      return((this.isKompex || this.kompex) && this.checkAuthorizationPKS) ? 100 : 50;
    },
    hintSchubladentarif() {
      if( (this.isKompex || this.kompex) &&
          this.checkAuthorizationPKS &&
          this.anzahlMitarbeiter > 50 &&
          this.anzahlMitarbeiter <= 100){
            return "Schubladentarif";
          } else {
            return "";
          }
    },
    ...mapGetters(
      [
        'anzahlMitarbeiter',
        'checkAuthorizationPKS'
      ]),
    ...mapTwoWay([
      'anzahlVollzeit',
      'anzahlTeilzeit',
      'anzahlSonstige',
      'anzahlFamilie',
      'anzahlInhaber'
    ], {
      anzahlVollzeit: 'vollzeit.anzahl',
      anzahlTeilzeit: 'teilzeit.anzahl',
      anzahlSonstige: 'sonstige.anzahl',
      anzahlFamilie: 'familie.anzahl',
      anzahlInhaber: 'inhaber.anzahl'
    }),
    ...mapTwoWay([
      'isKompex'
    ], {}, 'gewerbe.ui')
  },
  watch: {
    limitMitarbeiter() {
      this.validateRelevantMitarbeiter();
    },
    anzahlMitarbeiter() {
      this.validateRelevantMitarbeiter();
    }
  },
  created() {
    this.$validator.extend('mitarbeiteranzahl', {
      getMessage: function () {
        const limit = this.limitMitarbeiter;
        return `Es können online bis zu ${limit} (Vollzeit-)Mitarbeiter angegeben werden`;
      }.bind(this),
      validate: function (value) {
        if (!this.anzahlMitarbeiter || !this.limitMitarbeiter) {
          return true;
        }
        return !(value && this.anzahlMitarbeiter > this.limitMitarbeiter);
      }.bind(this)
    });
  },
  methods: {
    validateRelevantMitarbeiter() {
      let doSnackbar = [];
      let fnError = (function () {
        this.$store.dispatch('gewerbeShowDirektionsanfrage', {
          label: 'Mitarbeiter',
          limit: this.limitMitarbeiter,
        });
      }).bind(this);
      ['anzahlVollzeit', 'anzahlTeilzeit', 'anzahlSonstige'].forEach(a => {
        if (this[a]) {
          doSnackbar.push( this.$validator.validate(`${this.scope !== undefined ? this.scope + '.' : ''}${a}`));
          Promise.all(doSnackbar).then(res => {
            res.includes(false) ? fnError() : () => true;
          })
          .catch(err => {
            console.log(`ERROR in VALIDATION: ${err.message}`);
            fnError();
          });
        }
      });
    }
  }
};
</script>
<style>
.mitarbeiter-data .v-input {
  max-width: 344px;
}

.mitarbeiter-data div.v-input[aria-invalid=false] div.v-messages__wrapper .v-messages__message {
  color: #f57f17; /*assumes Schubladentarif to be the only non-error hint/label/message*/
}
</style>
